exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n#calendar {\n    font-family: 'Avenir', Helvetica, Arial, sans-serif;\n    height: 70vh;\n    width: 87vw;\n    padding-left: 15px;\n    padding-top: 20px;\n}\n.area_inner_side {\n    flex: 0 0 95%;\n    display: flex;\n}\n.area_inner h4 {\n    font-weight: 600;\n    margin-bottom: 5px;\n    font-size: 14px;\n    color: #0ce595;\n    margin-top: 5px;\n}\n.area_inner p {\n    font-size: 15px;\n    font-weight: 600;\n}\n.area_inner {\n    background: #0F6940;\n    padding: 10px;\n    border-radius: 5px;\n    margin-right: 15px;\n    margin-bottom: 15px;\n    color: #fff;\n    flex: 1;\n    max-width: 20%;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-d3a23cc0","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/views/helperAndDriverManagment/dutyTracking.vue
// module id = 239
// module chunks = 0